import { Component, OnDestroy } from '@angular/core';
import { faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import { NJDocDefTemplate } from '../../DOData';
//import { ICellRendererAngularComp } from '@ag-grid-community/angular';


@Component({
    selector: 'button-renderer',
    templateUrl: './button-cell-rending.component.html',
    styleUrls: ['./button-cell-rending.component.css']
})
export class ButtonRendererComponent {

    params;
    label: string;
    value: string;
    template: NJDocDefTemplate;
    isLink: boolean = false;
    ButonIcon: string;
    ButtonIcon = faTrashAlt;
    isDisabled: boolean = false;

    agInit(params): void {
        this.params = params;

        this.template = this.params.template
        //WO40459:Added NavigateToOOHSProviderQueue 
        if (
            this.template.dictCustomParameters.NavigateToFacesheet ||
            this.template.dictCustomParameters.NavigateToClaims ||
            this.template.dictCustomParameters.NavigateToAuths ||
            this.template.dictCustomParameters.NavigateToFSSApp ||
            this.template.dictCustomParameters.NavigateToAssessmentPanel ||
            this.template.dictCustomParameters.NavigateToProgNote ||
            this.template.dictCustomParameters.showValueNotLabel ||
            this.template.dictCustomParameters.NavigateToEligibilityRequest ||
            this.template.dictCustomParameters.NavigateToOOHSpecificFunctions ||
            this.template.dictCustomParameters.NavigateToFormsPanel ||
            this.template.dictCustomParameters.NavigateToEligibilityTermRequest ||
            this.template.dictCustomParameters.NavigateToOOHSProviderQueue ||
            this.template.dictCustomParameters.NavigateToTraige
        )
            this.label = this.params.value;
        else
            this.label = this.params.template.tLabel; //this.params.label || null;
        if (this.params.isLink == true)
            this.isLink = true;
        else
            this.isLink = false;
        this.ButonIcon = this.params.ButonIcon;

        if (this.params.isDisabled != undefined && this.params.isDisabled != null)
            this.isDisabled = this.params.isDisabled;

        this.value = this.params.value;
    }

    refresh(params?: any): boolean {
        return true;
    }
    getTextStyle(): object {
        if (this.isLink = true)
            return { "background": "none", "border": "none", "text-decoration": "underline", "font-size": "10pt","color":"royalblue" };
        else
            return null;
    }
    getClass() {
        let ret: string = "";
        if (this.isLink = true)
            ret = "btn-link";
        else
            ret = "btn btn-sm app-button";
        return ret;
    }

    onClick($event) {
        if (this.params.onClick instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data,
                value: this.value,
                template: this.template
                // ...something
            }
            this.params.onClick(this.params);

        }
    }
}